import { Injectable } from '@angular/core';
import { RmService } from '@bidi/common-services';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of } from 'rxjs';
import { catchError, switchMap, tap, mergeMap } from 'rxjs/operators';
import { ContentsLibraryActionTypes, GetTags, GetTagsSuccess, GetTagsFailure, GetResources, GetResourcesFailure, GetResourcesSuccess} from './actions';

@Injectable()
export class ContentsLibraryEffects {
   
    constructor (
        private actions$: Actions,
        private rm: RmService
    ) {
    }

    @Effect()
    getTags$ = this.actions$.pipe(
        ofType(ContentsLibraryActionTypes.GET_TAGS),
        mergeMap<GetTags, GetTagsSuccess | GetTagsFailure>(({ payload }) =>
        this.rm.getTags({ type : payload.type, limit: 100 }).pipe(
            switchMap(res => of(
                new GetTagsSuccess(res)
            )),
            catchError(err => of(
                new GetTagsFailure()
            ))
        )
        )
    );

    @Effect()
    getResources$ = this.actions$.pipe(
        ofType(ContentsLibraryActionTypes.GET_RESOURCES),
        mergeMap<GetResources, GetResourcesSuccess | GetResourcesFailure>(({ payload }) =>
        this.rm.getResources(payload).pipe(
            switchMap(res => of(
                new GetResourcesSuccess(res)
            )),
            catchError(err => of(
                new GetResourcesFailure()
            ))
        )
        )
    );
}  